module.exports = __webpack_public_path__ + "img/join-icon-02.e91b65f2.svg";